import { Outlet } from "react-router-dom";

const LayoutBg = ({ whiteBg, background = false }) => {
  return (
    <div
      className={`p-10 w-full h-[100dvh] ${whiteBg ? "bg-white dark:bg-gray-950" : background ? "bg-bg-light dark:bg-gray-950" : "bg-bg-gradient dark:bg-gray-950"}`}
    >
      <Outlet />
    </div>
  );
};

export default LayoutBg;
